import React from 'react';
import TimeUtil from 'utils/TimeUtil';
import { DARK_GREY, LIGHT_GREY } from 'constants/ColorConstants';

const CoderInfo = ({ coder, user, selected, index }) => {
  const time = TimeUtil.getDisplayTime(coder.time, true);
  const marginStyle = index > 0 ? { marginTop: '4px' } : {};
  const userName = user?.name || user?.email || 'Unknown User';

  return (
    <div
      className="coder"
      style={{
        ...marginStyle,
        color: !selected || coder.selected ? DARK_GREY : LIGHT_GREY,
      }}
    >
      Coded by {userName} {time}
    </div>
  );
};

export default CoderInfo;
